<template>
  <header class="hub-hero" id="home">
    <div class="container">
      <div class="hero-shell">
        <div class="hero-copy">
          <span class="eyebrow">Jens Trompler IT Consulting</span>
          <h1>
            <span class="text-gradient">IT-Beratung, Umsetzung und Produkte</span> für Unternehmen, die vorankommen wollen.
          </h1>
          <p>
            Hier finden Sie die einzelnen Bereiche von Jens Trompler IT Consulting. Wenn Sie ein Thema rund um Digitalisierung, Prozesse, Delivery oder neue Produkte haben, sehen Sie schnell, welcher Bereich am besten passt.
          </p>
          <div class="hero-actions">
            <router-link to="/#portfolio" class="btn-primary">Bereiche ansehen</router-link>
            <router-link to="/kontakt" class="btn-secondary">Kontakt aufnehmen</router-link>
          </div>
        </div>

        <div class="hero-panel">
          <div class="panel-card">
            <p class="panel-label">Aktuelle Bereiche</p>
            <ul>
              <li v-for="venture in ventureNames" :key="venture">{{ venture }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="hero-stats">
        <div v-for="stat in stats" :key="stat.label" class="stat-item">
          <strong>{{ stat.value }}</strong>
          <span>{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ventures } from '@/data/ventures';

export default {
  name: 'HubHero',
  computed: {
    ventureNames() {
      return ventures.map((venture) => venture.name);
    },
    stats() {
      return [
        { value: String(ventures.length), label: 'Bereiche und Produkte' },
        { value: '15+', label: 'Jahre Erfahrung in Delivery und Betrieb' },
        { value: '1', label: 'zentraler Ansprechpartner' }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/css/global.scss" as *;

.hub-hero {
  padding: 160px 0 90px;
  background:
    radial-gradient(circle at top right, rgba($accent-teal, 0.05), transparent 35%),
    radial-gradient(circle at 50% 10%, rgba($accent-purple, 0.05), transparent 40%),
    linear-gradient(180deg, #f7f9fb 0%, #eef2f6 55%, #e6edf3 100%);
  color: $text-color;
}

.hero-shell {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(280px, 0.7fr);
  gap: 2rem;
  align-items: center;
}

.eyebrow {
  display: inline-block;
  margin-bottom: 1rem;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba($accent-color, 0.08);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.hero-copy p {
  max-width: 680px;
  margin-bottom: 2rem;
  color: $text-color;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.hero-panel {
  display: flex;
  justify-content: flex-end;
}

.panel-card {
  width: 100%;
  max-width: 360px;
  padding: 1.8rem;
  border: 1px solid rgba($accent-color, 0.08);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: $shadow-xl;
}

.panel-label {
  margin-bottom: 1rem;
  color: $text-muted;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.panel-card ul {
  margin: 0;
  padding-left: 1.2rem;
}

.panel-card li + li {
  margin-top: 0.85rem;
}

.hero-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 2rem;
}

.stat-item {
  padding: 1.15rem 1.25rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba($accent-color, 0.08);
}

.stat-item strong {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 1.6rem;
}

.stat-item span {
  color: $text-muted;
}

@media (max-width: 991px) {
  .hero-shell,
  .hero-stats {
    grid-template-columns: 1fr;
  }

  .hero-panel {
    justify-content: stretch;
  }

  .panel-card {
    max-width: none;
  }
}
</style>
